import { useEffect } from 'react';

let desktopResizeTracked = false;

/**
 * Sends `Game:ResizeTriggered` (GameAnalytics) and `game` / `resize_triggered`
 * (GA4) the first time the window is resized after the game has loaded.
 *
 * Desktop only, and once per page load. The deferred senders queue the event
 * until the analytics clients are available, so it is not lost.
 *
 * @param {Object} options
 * @param {boolean} options.gameLoaded - Whether the game has finished loading.
 * @param {boolean} options.isMobileDevice - Mobile/tablet devices never send it.
 * @param {Function} options.sendGameDesignEvent - Deferred GameAnalytics design event.
 * @param {Function} options.sendGoogleBasicEvent - Deferred Google Analytics basic event.
 */
export const useDesktopResizeAnalytics = ({
    gameLoaded,
    isMobileDevice,
    sendGameDesignEvent,
    sendGoogleBasicEvent,
}) => {
    useEffect(() => {
        if (!gameLoaded || isMobileDevice || desktopResizeTracked) return;

        const handleResize = () => {
            if (desktopResizeTracked) return;

            desktopResizeTracked = true;
            sendGameDesignEvent('Game:ResizeTriggered');
            sendGoogleBasicEvent('game', 'resize_triggered');
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [gameLoaded, isMobileDevice, sendGameDesignEvent, sendGoogleBasicEvent]);
};
